import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { Button, Collapse, Modal, ModalBody, ModalHeader } from 'reactstrap';
import Icon from '@material-ui/core/Icon';
import InputFeild from "../../global/form/input";
import ImageUploadFeild from "../../global/form/upload-image";
import { setError, setLoader, setSuccess } from "../../../actions/action-creators";
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import moment from "moment";
import ConfirmAction from "../../global/confirm-action";
import SelectList from "../../global/form/select";
import VideoUploadFeild from "../../global/form/upload-video";
import { Chip } from "@material-ui/core";
import CONSTANTS from "../../../constants";







class ManageAppVideos extends Component {
    constructor(props) {
        super(props);
        this.state = {
          isAddSection: false,
          videoSectionsList: [],
          isAddVideo: false,
          isOpenConfirm: false,
          draggedSectionIndex: null,
          draggedVideoIndex: null
        }
    }

        handleDragSection = (e) => {
            this.setState({draggedSectionIndex: e.currentTarget.id});
        }
    
        handleDropSection = async (e) => {
            let { draggedSectionIndex } = this.state;
            let droppedSectionIndex = e.currentTarget.id;
            if(!draggedSectionIndex || !droppedSectionIndex) return; 

            let sections = [...this.state.videoSectionsList];

            let draggedSection = sections.splice(draggedSectionIndex, 1);

            if(!draggedSection[0]) return;

            sections.splice(droppedSectionIndex, 0, draggedSection[0])
            
            sections = sections.map((section, i) => {
                section.order_index = i + 1;
                return section;
            });
            let updateData = sections.filter((section, i) => draggedSectionIndex > droppedSectionIndex ?  i >= droppedSectionIndex : i >= draggedSectionIndex && i <= droppedSectionIndex).map(section => ({video_section_id: section.video_section_id, order_index: section.order_index}));
            await Promise.all(updateData.map(async section => {
                await ApiEndpoints.Videos.editSection(section)
            }));
            this.setState({ videoSectionsList: [...sections] })
        }
          
        
        handleDragVideo = (e) => {
            this.setState({draggedVideoIndex: e.currentTarget.id});
        }
    
        handleDropVideo = async (e, videoSectionId, videos) => {
            let { videoSectionsList } = this.state;
            
            let { draggedVideoIndex } = this.state;
            let droppedVideoIndex = e.currentTarget.id;

            if(!draggedVideoIndex || !droppedVideoIndex) return; 

            let draggedVideo = videos.splice(draggedVideoIndex, 1);

            if(!draggedVideo[0]) return;

            videos.splice(droppedVideoIndex, 0, draggedVideo[0])
            
            videos = videos.map((section, i) => {
                section.order_index = i + 1;
                return section;
            });
            let updateData = videos.filter((video, i) => draggedVideoIndex > droppedVideoIndex ?  i >= droppedVideoIndex : i >= draggedVideoIndex && i <= droppedVideoIndex).map(video => ({video_id: video.video_id, order_index: video.order_index}));
            await Promise.all(updateData.map(async section => {
                await ApiEndpoints.Videos.editVideo(section)
            }));

            videoSectionsList = videoSectionsList.map(section => {
                if(section.video_section_id === videoSectionId) section.Videos = [...videos];
                return section;
            })

            this.setState({ videoSectionsList })
        }
        
    
    componentDidMount(){
        this.videoSectionsList();
    }

    videoSectionsList = async() => {
        store.dispatch(setLoader(true))
        try{
            let apiData = await ApiEndpoints.Videos.fetchVideoSections();
            let videoSectionsList = apiData.data.data;
            this.setState({ videoSectionsList })
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false));

    }


    previewVideo = (videoUrl) => {
        window.open(videoUrl, "_blank")
    }
    
    addVideoSection = async (e) => {
        e.preventDefault();
        let { isAddSection } = this.state;

        let sectionData = {
            title: isAddSection.title,
            description: isAddSection.description || "",
            entity_type:  isAddSection.entity_type,
        };
        store.dispatch(setLoader(true));
        if(isAddSection.video_section_id) {
            sectionData.video_section_id = isAddSection.video_section_id
            await ApiEndpoints.Videos.editSection(sectionData);
        }
        else await ApiEndpoints.Videos.addSection(sectionData);
        await this.videoSectionsList();
        await this.setState({isAddSection:false})
        store.dispatch(setLoader(false));
    }

    expendSection = (videoSectionId, isExpended) => {
        let { videoSectionsList } = this.state;
        videoSectionsList = videoSectionsList.map(section => {
            console.log(videoSectionId && videoSectionId === section.video_section_id)
            if(videoSectionId){
                if(videoSectionId === section.video_section_id) section.isExpended = isExpended;
            }
            else section.isExpended = isExpended;
            return section
        });
        this.setState({ videoSectionsList })
    }
        

    getVideoFileMeta = (e) => {
        let { isAddVideo } = this.state;
        // let checkSize = e.target.duration * 204.8; //per second 200kb (1024/10)
        // var fileSize = isAddMediaContent.file.size/1024;

        // if(fileSize > checkSize){
        //     isAddMediaContent.file = null;
        //     this.setState({ isAddMediaContent });
        //     return store.dispatch(setError({show: true, message: `Video size must be below ${checkSize}KB (200kb/second)`}));
        // }
        isAddVideo.duration = e.target.duration;
        this.setState({ isAddVideo });
    }


    addVideo = async () => {


        let { isAddVideo, videoSectionsList } = this.state;
        let selectedVideoSection = videoSectionsList.filter(section => section.video_section_id === isAddVideo.video_section_id)[0];
        let newOrderIndex = Math.max(...selectedVideoSection.Videos.map(v => v.order_index));


        store.dispatch(setLoader(true));
        try{
            var contentBody = {
                video_section_id : isAddVideo.video_section_id,
                title : isAddVideo.title,
                description : isAddVideo.description,
                duration: isAddVideo.duration,
                entity_type: isAddVideo.entity_type || "GENERIC",
                entity_id: isAddVideo.entity_id || 0,
                order_index: newOrderIndex + 1
            };
           
            if(isAddVideo.thumbnail_file) {
                let fileName = "training_video/"+(isAddVideo.entity_type || "GENERIC");
                if(isAddVideo.entity_id) fileName += "/"+isAddVideo.entity_id;
                fileName += "/"+ new Date().getTime() + "_" + isAddVideo.thumbnail_file.name;
                let fileResp = await ApiEndpoints.Files.filePublicPutUrl({file_name: fileName});
                let file_url = fileResp.data.data.url;
                if (!file_url) throw new Error("Unable to upload file. Please try again later.");
                let config = { headers: { "Content-Type": isAddVideo.thumbnail_file.type }}
                await ApiEndpoints.Files.uploadFileToS3(file_url, isAddVideo.thumbnail_file, config);
                contentBody.thumbnail_url = fileResp.data.data.fileUrl;
            } 
            
            if(isAddVideo.video_file) {
                let fileName = "training_video/"+(isAddVideo.entity_type || "GENERIC");
                if(isAddVideo.entity_id) fileName += "/"+isAddVideo.entity_id;
                fileName += "/"+ new Date().getTime() + "_" + isAddVideo.video_file.name;
                let fileResp = await ApiEndpoints.Files.filePublicPutUrl({file_name: fileName});
                let file_url = fileResp.data.data.url;
                if (!file_url) throw new Error("Unable to upload file. Please try again later.");
                let config = { headers: { "Content-Type": isAddVideo.video_file.type }}
                await ApiEndpoints.Files.uploadFileToS3(file_url, isAddVideo.video_file, config);
                contentBody.video_url = fileResp.data.data.fileUrl;
            }
          
            if(isAddVideo.video_id) {
                contentBody.video_id = isAddVideo.video_id;
                await ApiEndpoints.Videos.editVideo(contentBody);
            }
            else await ApiEndpoints.Videos.addVideo(contentBody);
            this.setState({ isAddVideo: false })
            this.videoSectionsList();
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        this.setState({addMediaContentProgress : false, isAddMediaContent: {}})
        store.dispatch(setLoader(false))

    }

    setIsEditSection = (section) => {
        this.setState({ isAddSection: section })
    }

    deleteVideo = async (video) => {
        let { videoSectionsList } = this.state;
        store.dispatch(setLoader(true))
        try{
            await ApiEndpoints.Videos.deleteVideo({ video_id: video.video_id });
            videoSectionsList = videoSectionsList.map(section=> {
                if(section.video_section_id === video.video_section_id){
                    section.Videos = section.Videos.filter(v => v.video_id !== video.video_id);
                }
                return section;
            });
            this.setState({ videoSectionsList })
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }


    render() {
        let { isAddSection, videoSectionsList, isAddVideo } = this.state;
        let jobList = store.getState().jobList

        return (
            <>
                <Button id="add_section" onClick={() => this.setState({isAddSection : isAddSection ? false : {}})} type="button" className="buttonred" size="xs" style={{ height: "27px", paddingTop: "3px"}}>Add New Section</Button>

               

                <div className="mt-3">

                {
                    videoSectionsList.map((section, i) => {
                        return (
                        <div className="mb-3" style={{}}>
                            <div className="bg-light shadow-sm px-3 py-2" style={{borderRadius: 8}}  id={i} draggable={true} onDragOver={(ev) => ev.preventDefault()} onDragStart={this.handleDragSection} onDrop={this.handleDropSection} >
                                <Row className="align-items-center">
                                    <Col xs={8}>
                                        <span className="d-block font-weight-bold">{section.title}</span>
                                        <span className="small">{section.description}</span>
                                    </Col>
                                    <Col xs={4} className="text-right">
                                        <Icon className="align-middle mr-3" onClick={() => this.setIsEditSection({...section, Videos: []} )}>edit</Icon> 
                                        <Icon className="align-middle mr-3 clickable" title="Add Video" onClick={() => this.setState({ isAddVideo: { video_section_id: section.video_section_id } })}>add</Icon> 
                                        <Icon className="align-middle mr-3 clickable">reorder</Icon> 
                                        <Icon style={{fontSize: 20, cursor: "pointer"}} className="align-middle clickable" onClick={() => this.expendSection(section.video_section_id, !section.isExpended)}>unfold_more</Icon>
                                    </Col>
                                </Row>
                            </div>
                            {!!section.isExpended && 
                            <div className="p-2">
                                <Row className="" style={{flexWrap: "nowrap", overflowX: "auto"}}>
                                    {
                                        section.Videos.map((video, videoIndex) => {
                                            return (
                                                <Col xs={2} className="text-center visible-on-hover-container"  id={videoIndex} draggable={true} onDragOver={(ev) => ev.preventDefault()} onDragStart={this.handleDragVideo} onDrop={(e) => this.handleDropVideo(e, section.video_section_id, section.Videos)} >
                                                    <div className="shadow-sm p-2 h-100" style={{borderRadius: 8, background: "#eee"}}>
                                                        <img style={{width: "85%", borderRadius: 12}} src={video.thumbnail_url} alt={"video_banner"} className="clickable" onClick={() => this.previewVideo(video.video_url)} />
                                                        <span className="mt-2 small d-block">{video.title}</span>
                                                        <em title={video.description} className="limit-text-2" style={{fontSize: 10, color: "#666"}}>{video.description}</em>
                                                    </div>
                                                    <div className="visible-on-hover-item d-flex" style={{position: "absolute", top: 0, right: -5, flexDirection: "column" }}>
                                                        <Icon className="clickable" style={{fontSize: 18}} onClick={() => this.setState({isAddVideo: video})}>edit</Icon>
                                                        <Icon className="mt-2 clickable" style={{fontSize: 18}}  onClick={() => this.setState({ isOpenConfirm: () => this.deleteVideo(video) })}>delete</Icon>
                                                    </div>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>
                            </div>}
                        </div>
                        )
                    })
                }
                </div>


                <Modal size="lg" isOpen={isAddSection} toggle={()=> {this.setState({isAddSection : false})}} >
                    <ModalHeader toggle={()=> {this.setState({isAddSection : false})}}>Add Video Section</ModalHeader>
                    <ModalBody className="">
                        <form onSubmit={this.addVideoSection}>
                            <Row className="mb-3">
                                <Col style={{marginRight: "-27px"}}>
                                    <Collapse className="card p-3" isOpen={!!isAddSection}>
                                        <Row className="mt-3 align-items-center">
                                            <Col xs={6}><InputFeild   placeholder="Title" value={isAddSection.title || ""} onChange={(e) => { isAddSection.title=e.target.value; this.setState({ isAddSection }) }}/></Col>
                                            <Col xs={6}><InputFeild  placeholder="Description" value={isAddSection.description || ""} onChange={(e) => { isAddSection.description=e.target.value; this.setState({ isAddSection}) }}/></Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col xs={6}>
                                                <SelectList placeholder="Select* " value={isAddSection.entity_type} onChange={(e) => { isAddSection.entity_type=e.target.value; this.setState({ isAddSection}) }} >
                                                    <option value={"APP"}>App Training</option>
                                                    <option value={"GENERIC"}>General Training</option>
                                                    <option value={"JOB_CATEGORY"}>Projects Training</option>
                                                </SelectList>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="text-right">
                                                <Button className="buttonred m-2 py-2">{isAddSection.video_section_id ? "Update" : "Create"}</Button>
                                                <Button onClick={() => this.setState({isAddSection : false})} className="buttonred m-2 py-2">Cancel</Button>
                                            </Col>
                                        </Row>
                                    </Collapse>
                                </Col>
                            </Row>
                        </form>
                    </ModalBody>
                </Modal>


                        
                <Modal size="lg" isOpen={isAddVideo} toggle={()=> {this.setState({isAddVideo : false})}} >
                    <ModalHeader toggle={()=> {this.setState({isAddVideo : false})}}>Add Video</ModalHeader>
                    <ModalBody className="">
                        <Row className="mt-3 align-items-center">
                            <Col xs={6}><InputFeild  placeholder="Title" value={isAddVideo.title || ""} onChange={(e) => { isAddVideo.title=e.target.value; this.setState({ isAddVideo }) }}/></Col>
                            <Col xs={6}><InputFeild  placeholder="Description" value={isAddVideo.description || ""} onChange={(e) => { isAddVideo.description=e.target.value; this.setState({ isAddVideo}) }}/></Col>
                        </Row>
                         <Row className="mt-3">
                            <Col xs={6}>
                                <SelectList placeholder="Select" value={isAddVideo.entity_type} onChange={(e) => { isAddVideo.entity_type=e.target.value; this.setState({ isAddVideo}) }} >
                                    <option value={"APP"}>App Training</option>
                                    <option value={"GENERIC"}>General Training</option>
                                    <option value={"JOB"}>Projects Training</option>
                                </SelectList>
                            </Col>
                            {isAddVideo.entity_type === "JOB" && 
                            <Col xs={6}>
                                <SelectList search={true} placeholder="Select Project" value={isAddVideo.entity_id} onChange={(e) => { isAddVideo.entity_id=e.target.value; this.setState({ isAddVideo}) }} >
                                    { 
                                        jobList.map(job => 
                                        <option key={job.job_id} value={job.job_id}> 
                                            {job.Employer.employer_name +  "  -  "  + job.title} 
                                            {job.archive_status !== 0 && <Chip size="small" style={{fontSize: 8}} className="ml-3" label={CONSTANTS.ARCHIVE_STATUS_TEXT[job.archive_status]} /> }
                                        </option>
                                    )}
                                </SelectList>
                            </Col>}
                        </Row>
                        <Row className="mt-3 align-items-center" style={{justifyContent: "space-around"}}>
                            <Col xs={4}>
                                <ImageUploadFeild required className="my-2 text-center" label="Add Thumbnail" src={isAddVideo.thumbnail_url} onChange={(file) => {isAddVideo.thumbnail_file = file; this.setState({isAddVideo})}} />
                            </Col>
                            <Col xs={4} >
                                <VideoUploadFeild id="video_upload_input_training" label={"Add Video"} src={isAddVideo.video_url} onChange={(file) => {isAddVideo.video_file = file; this.setState({isAddVideo})}} onLoadedMetadata={this.getVideoFileMeta} />
                            </Col>
                        </Row>
                        
                        <Row className="mt-3 border-top py-2">
                            <Col className="text-right">
                                <Button onClick={() => this.addVideo()} className="buttonred m-2 py-2">Save</Button>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>


                <ConfirmAction isOpen={!!this.state.isOpenConfirm} callback={this.state.isOpenConfirm} onClose={() => this.setState({isOpenConfirm : false, confirmMessage : null})} />
         
            </>
        )}};
    
    export default ManageAppVideos;




   

